module.exports = __webpack_public_path__ + "static/media/cnito-sizzle-es.fd39bdb1.mp4";